// components/AssinaturaPFX.tsx
import { Box, Button, Paper, Typography } from "@mui/material";
import { useState } from "react";

const AssinaturaPFX: React.FC = () => {
  const [arquivoPfx, setArquivoPfx] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    if (event.target.files?.length) {
      setArquivoPfx(event.target.files[0]);
    }
  };

  const handleSign = (): void => {
    if (!arquivoPfx) return;
   
    // Adicione a lógica de assinatura usando o PFX aqui
  };

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6">Assinar com Certificado PFX</Typography>
      <Box mt={2}>
        <Button variant="outlined" component="label">
          Carregar PFX
          <input hidden type="file" accept=".pfx" onChange={handleFileChange} />
        </Button>
        {arquivoPfx && <Typography mt={1}>{arquivoPfx.name}</Typography>}
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSign}
            disabled={!arquivoPfx}
          >
            Assinar
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default AssinaturaPFX;
